import React from "react";
import PropTypes from "prop-types";
import { RadioGroup } from "@progress/kendo-react-inputs";
import "./RadioGroup.scss";

/**
 * RadioGroup
 * @module
 * @param {array} data - All data for options
 * @param {string} textField - Text field
 * @param {string} dataItemKey - Data item key
 * @param {object} [value] - Current value
 * @param {func} onChange - Function invoked on value change
 * @param {bool} [disabled] - Is input readonly?
 * @param {string} name - Name
 * @param {number} [tabIndex] - Tabindex
 * @param {string} [className] - Class name
 * @param {string} [layout] -  Value can be 'horizontal'/'vertical' - default 'vertical'
 */
const RadioGroupComponent = (props) => {
  const getValue = () => {
    let value = props.value?.[props.dataItemKey];

    if (value === null && props.data) {
      const data = getData();
      value = data.length > 0 ? data[0].value : null;
      props.onChange(
        props.name,
        props.data.find((x) => x[props.dataItemKey] === value)
      );
    }

    return value;
  };

  const onChange = (e) => {
    const value = props.data.find((x) => x[props.dataItemKey] === e.value);
    props.onChange(props.name, value);
  };

  const getData = () => {
    return props.data.map((x) => {
      return {
        label: x[props.textField],
        value: x[props.dataItemKey],
        disabled: x.disabled,
      };
    });
  };

  return (
    <RadioGroup
      className={`radiogroup ${props.className || ""} ${
        props.disabled ? "disabled-field" : ""
      } `}
      data={getData()}
      value={getValue()}
      onChange={onChange}
      disabled={props.disabled}
      tabIndex={props.tabIndex}
      layout={props.layout}
    />
  );
};

RadioGroupComponent.propTypes = {
  data: PropTypes.array.isRequired,
  textField: PropTypes.string.isRequired,
  dataItemKey: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  className: PropTypes.string,
  layout: PropTypes.string,
};

export default RadioGroupComponent;
